'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerContractOverviewComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sellerContractOverviewComponent = exports.sellerContractOverviewComponent = {
    template: require('./contract-overview.html'),
    bindings: {
        contracts: '<',
        seller: '<'

    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "Analytics", function contractsOverviewController(common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.sortBy = sortBy;
        vm.reverse = false;
        vm.propertyName = 'name';
        vm.checkYearsApart = checkYearsApart;

        function init() {
            common.navigationMenu.clearActiveMenu();

            common.setTitle(vm.seller.name + ' ' + gettextCatalog.getString('contracts'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/contract', vm.seller.name + ' ' + gettextCatalog.getString('contract'));
        }

        function sortBy(propertyName) {
            vm.reverse = vm.propertyName === propertyName ? !vm.reverse : false;
            vm.propertyName = propertyName;
        }

        function checkYearsApart(contract) {
            return (0, _moment2.default)(contract.endDate).format('YYYY') - (0, _moment2.default)(contract.startDate).format('YYYY') > 10 ? true : false;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/contract-overview.js
// module id = 1016
// module chunks = 0